import * as React from 'react';
import { SVGProps } from 'react';
import styled from 'styled-components';

const SVG = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m2 5-.182-.728A.75.75 0 0 0 1.47 5.53L2 5Zm12-3 .728.182a.75.75 0 0 0-.91-.91L14 2Zm-3 12-.53.53a.75.75 0 0 0 1.258-.348L11 14ZM5.375 8.375l-.53.53a.75.75 0 0 0 .636.212l-.106-.742Zm2.25 2.25-.742-.106a.75.75 0 0 0 .212.636l.53-.53ZM10.78 6.28a.75.75 0 1 0-1.06-1.06l1.06 1.06Zm-8.598-.552 12-3-.364-1.456-12 3 .364 1.456Zm11.09-3.91-3 12 1.456.364 3-12-1.456-.364Zm-5.378 5.44-2.625.375.212 1.484 2.625-.375-.212-1.484Zm.473 3.473.375-2.625-1.484-.212-.375 2.625 1.484.212Zm3.163 2.739-3.375-3.375-1.06 1.06 3.375 3.375 1.06-1.06ZM5.905 7.845 2.53 4.47 1.47 5.53l3.375 3.375 1.06-1.06Zm2.625.685 2.25-2.25-1.06-1.06-2.25 2.25 1.06 1.06Z"
      fill="currentColor"
    />
  </svg>
);

const StyledSvgPaperPlane = styled(SVG)`
  font-size: ${props => (props.fontSize ? props.fontSize : '1.6rem')};
  color: ${({ color, theme }) =>
    color ? color : theme.colors.neutralColors.charcoal};
  vertical-align: middle;
  shape-rendering: inherit;
  transform: translate3d(0, 0, 0);
`;
export default StyledSvgPaperPlane;
